var module = angular.module('octopusApp.infrastructure');

module.filter('csvToArray', function () {
  return function (input) {
    if (!input) {
      input = "";
    }

    return input.split(',');
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/filters/csv-to-array.js
// module id = 685
// module chunks = 1